'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { parseAsString, useQueryState } from 'nuqs';
import type { CommonCmsBlockProps } from '@/components/blocks/CmsBlock';
import { VehicleCompareProvider } from '@/components/blocks/cms/VehicleCompareBlock/VehicleCompareContext';
import { SOURCE_BLOCK_ID_QUERY_PARAM_NAME } from '@/components/blocks/cms/VehicleCompareBlock/config';
import type { CmsFleetCategory } from '@/services/cms-sdk';
export interface VehicleCompareBlockComparisonWrapperProps extends CommonCmsBlockProps {
  children: ReactNode;
  fleetCategories: CmsFleetCategory[];
}
export function VehicleCompareBlockComparisonWrapper(t0) {
  const $ = _c(4);
  const {
    children,
    fleetCategories
  } = t0;
  const [queryBlockId] = useQueryState(SOURCE_BLOCK_ID_QUERY_PARAM_NAME, parseAsString);
  const t1 = queryBlockId || 0;
  let t2;
  if ($[0] !== children || $[1] !== fleetCategories || $[2] !== t1) {
    t2 = <VehicleCompareProvider blockId={t1} fleetCategories={fleetCategories}>{children}</VehicleCompareProvider>;
    $[0] = children;
    $[1] = fleetCategories;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}